export default "__VITE_ASSET__DPREH8sH__"